import React from "react";

import styled from "styled-components";

import { Card, CardBody, Col, Container, Row } from "reactstrap";
import Breadcrumbs from "../../../../components/Common/Breadcrumb";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import {
  getSelectedMonthAgoWithFirstDay,
  numberWithCommas,
  getSelectedMonthAgoWithLastDay,
  downloadCSVReactTable,
} from "../../../../helpers/utils";
import DynamicFormFilters from "../../../../components/forms/DynamicFormFilters";
import AggregatedTable from "../common/tables/AggregatedTable";
import ReactTableForm from "../../../../components/Common/ReactTableForm";
import AggregatedTableForHR from "../common/tables/AggregatedTableForHR";

const DEFAULT_REPORT_WIDGET = [
  {
    icon: "bx bx bx-table",
    title: "Plan",
    value: 0,
  },
  {
    icon: "bx bx bx-stats",
    title: "Profit",
    value: 0,
  },
  {
    icon: "bx bx-wallet-alt",
    title: "Rent profit",
    value: 0,
  },
  {
    icon: "mdi mdi-cash-plus",
    title: "Percent %",
    value: 0,
  },
  {
    icon: "bx bx-credit-card",
    title: "Debit",
    value: 0,
  },
  {
    icon: "bx bxs-credit-card",
    title: "Overdue debt",
    value: 0,
  },
  {
    icon: "bx bx-money",
    title: "Costs",
    value: 0,
  },
];

const spinnerWidget = (
  <div className="loader-for-react-widget">
    <div className="spinner-border text-primary m-1" role="status">
      <span className="sr-only">Loading...</span>
    </div>
  </div>
);

const indexOptions = [
  {
    id: "profit",
    name: "Profit",
  },
  {
    id: "cost",
    name: "Cost",
  },
  {
    id: "margin",
    name: "Margin",
  },
];

const HROverview = props => {
  const [date, setDate] = React.useState({
    start_date: getSelectedMonthAgoWithFirstDay(0),
    end_date: getSelectedMonthAgoWithLastDay(-1),
  });
  const [activeFilters, setActiveFilters] = React.useState({});
  const [tablesDataForExport, setTablesDataForExport] = React.useState({});
  const [indexSelected, setIndexSelected] = React.useState(indexOptions[0]);
  const [isAdmin, setIsAdmin] = React.useState({
    id: "",
    status: false,
  });

  const renderOverviewName = () => {
    const { permissions } = props;
    if (
      permissions["is_head_of_mediabuyer"] ||
      permissions["is_head_of_accountmanager"] ||
      permissions["is_admin"] ||
      permissions['is_finance'] ||
      permissions['is_hr']
    ) {
      return "Top Management";
    }

    if (permissions["is_accountmanager"] || permissions["is_mediabuyer"]) {
      return "Individual Report";
    }

    return "Top Management";
  };

  const handleUserPosition = (user, managers) => {
    const { permissions } = props;

    if (
      permissions["is_head_of_mediabuyer"] ||
      permissions["is_head_of_accountmanager"] ||
      permissions["is_admin"] ||
      permissions['is_finance'] ||
      permissions['is_hr']
    ) {
      return setIsAdmin({ status: true, id: "" });
    }

    if (permissions["is_accountmanager"]) {
      let idx = managers.findIndex(m => m.email == user.email);
      idx > 0 && setIsAdmin({ status: false, id: managers[idx].id });
    }

    if (permissions["is_mediabuyer"]) {
      let idx = managers.findIndex(m => m.email == user.email);
      idx > 0 && setIsAdmin({ status: false, id: managers[idx].id });
    }
  };

  React.useEffect(() => {
    const { permissions } = props;

    let data = {};
    data.start_date = getSelectedMonthAgoWithFirstDay(0);
    data.end_date = getSelectedMonthAgoWithLastDay(-1);

    if (
      permissions["is_head_of_mediabuyer"] ||
      permissions["is_head_of_accountmanager"] ||
      permissions["is_admin"] ||
      permissions['is_finance'] ||
      permissions['is_hr']
    ) {
      props.getCustomFilters({ buyer: false });
      props.getTopManagementReportsFilters({
        date_from: data.start_date,
        date_to: data.end_date,
      });
      // props.getAggregatedStaffData({
      //   date_from: data.start_date,
      //   date_to: data.end_date,
      // })
      // props.getHRDetailedOffers({
      //   date_from: data.start_date,
      //   date_to: data.end_date,
      // })
    } else {
      if (permissions["is_accountmanager"]) {
        props.getCustomFilters({ buyer: false });
        props.getTopManagementReportsFilters({
          account_manager: props.user.id,
          date_from: data.start_date,
          date_to: data.end_date,
        });
      } else if (permissions["is_mediabuyer"]) {
        props.getCustomFilters({ buyer: true });
        props.getTopManagementReportsFilters({
          media_buyer: props.user.id,
          date_from: data.start_date,
          date_to: data.end_date,
        });
      }
    }

    setIndexSelected(indexOptions[0]);

    return () => {
      setIndexSelected({});
      props.setProfitPlansWidgetData(DEFAULT_REPORT_WIDGET);
      props.setTopManagementReportsFilters({
        offers: [],
        managers: [],
        buyers: [],
        platforms: [],
      });
      setTablesDataForExport({})
    };
  }, []);

  React.useEffect(() => {
    if (props.topReportsFilters?.managers?.length > 0) {
      handleUserPosition(props.user, props.topReportsFilters.managers_more);
    }
  }, [props.topReportsFilters]);

  React.useEffect(() => {
    setTablesDataForExport({
      ...(props.hrOffersData?.data && {
        offers: {
          data: props.hrOffersData?.data,
          columns: props.hrOffersData?.head,
        }
      }),
      ...(props.staffData?.data && {
        staff: {
          data: props.staffData?.data,
          columns: props.staffData?.head,
        }
      }),
    });
  }, [props.hrOffersData, props.staffData])
  const handleDateRangeChange = async (filterDate) => {
    setDate(filterDate);
    props.getAggregatedStaffData({
      date_from: filterDate.start_date,
      date_to: filterDate.end_date,
    })
    props.getHRDetailedOffers({
      date_from: filterDate.start_date,
      date_to: filterDate.end_date,
    })
  };

  const activeAccountManager = managers => {
    if (
      isAdmin?.status ||
      props.permissions["is_head_of_mediabuyer"] ||
      props.permissions["is_head_of_accountmanager"] ||
      props.permissions["is_mediabuyer"]
    ) {
      return managers;
    } else {
      return props.user.id;
    }
  };

  const handleMainFiltersTrigger = (filter, type, status) => {
    const { permissions } = props;
    let primaryChanged = "";
    let selectedIdx = "";
    let params = {};
    let days = {
      date_from: filter.start_date || date.start_date,
      date_to: filter.end_date || date.end_date,
    };

    if (filter?.offers && filter?.offers.length > 0) {
      params.offer = filter.offers.join(",");
    }

    if (filter?.users && filter?.users.length > 0) {
      params.user_ids = filter.users.join(",");
    }

    if (filter?.index) {
      let idx = indexOptions.findIndex(i => i.id === filter.index.join(","));
      setIndexSelected(indexOptions[idx]);
      selectedIdx = filter.index.join(",");
    } else {
      selectedIdx = indexSelected.id;

      setActiveFilters({
        ...params,
        ...days,
      });
    }

    Object.keys(params).forEach(key => {
      if (key in activeFilters) {
        if (params[key]?.length !== activeFilters[key]?.length) {
          primaryChanged = key;
        }
      }
    });

    setDate({
      start_date: filter.start_date || date.start_date,
      end_date: filter.end_date || date.end_date,
    });

    if (params?.buyers == "") {
      delete params.buyers;
    }

    if (params?.account_manager == "") {
      delete params.account_manager;
    }

    if (type != "permit") {
      if (
        status == "INITIAL" ||
        primaryChanged == "account_manager" ||
        primaryChanged == "buyers" ||
        primaryChanged == "offer"
      ) {

      }

      props.getProfitPlansWidgetData({
        ...params,
        ...days,
      });

      props.getAggregatedOfferProfit({
        ...params,
        ...days,
      });

      props.getAggregatedStaffData({
        // ...params,
        ...(params?.user_ids && {
          user_ids: params?.user_ids
        }),
        ...days,
      })

      props.getHRDetailedOffers({
        ...params,
        ...days,
      })
    } else {

    }

    // setTablesDataForExport({});
  };

  const handleChangeTableData = type => {
    const { start_date, end_date } = date;
    downloadCSVReactTable(
      tablesDataForExport[type]?.data,
      [],
      `Report-${type.charAt(0).toUpperCase() + type.slice(1)
      }[${start_date} - ${end_date}]`
    );
  };

  const handleUpdateTable = data => {
    setTablesDataForExport({
      ...tablesDataForExport,
      ...data,
    });
  };

  const handleShowAccountManagers = () => {
    if (
      props.permissions["is_admin"] ||
      props.permissions["is_head_of_accountmanager"] ||
      props.permissions['is_finance'] ||
      props.permissions['is_hr']
    )
      return false;
    if (
      props.permissions["is_accountmanager"] ||
      props.permissions?.["is_head_of_mediabuyer"] ||
      props.permissions?.["is_mediabuyer"]
    )
      return true;
  };

  // const handleShowBuyers = () => {
  //   if (
  //     props.permissions["is_admin"] ||
  //     props.permissions["is_head_of_mediabuyer"] ||
  //     props.permissions['is_finance'] ||
  //     props.permissions['is_hr']
  //   )
  //     return false;
  //   if (
  //     props.permissions["is_mediabuyer"] ||
  //     props.permissions["is_accountmanager"]
  //   )
  //     return true;
  // };

  return (
    <>
      <React.Fragment>
        {Object.entries(props.customFilters).length > 0 ? (
          <StyledContainer fluid>
            <Breadcrumbs
              title="Dashboard"
              breadcrumbItem={renderOverviewName()}
              link="/overview"
            />
            <DynamicFormFilters
              onFiltersChange={handleMainFiltersTrigger}
              onDateRangeChange={handleDateRangeChange}
              isLoadingSelect={props.topReportsFiltersLoading}
              disableFilterBy
              filtersFields={[
                {
                  filterData: props.customFilters?.users,
                  title: "Staff",
                  plug: "Staff...",
                  filterType: "users",
                  customWidth: "230px",
                  hidden: handleShowAccountManagers(),
                  style: {
                    marginLeft: "auto",
                  },
                },
                // {
                //   filterData: indexOptions,
                //   title: "Index",
                //   plug: "Index...",
                //   filterType: "index",
                //   customWidth: "230px",
                //   defaultValue: indexSelected || indexOptions[0],
                //   singleSelect: true,
                // },
                {
                  filterData: props.topReportsFilters?.offers,
                  title: "Offers",
                  plug: "Offers...",
                  filterType: "offers",
                  customWidth: "230px",
                },
              ]}
              filtered_by={[
                "users",
                // "index",
                "offers",

              ]}
              filtered_params={['users']}
              selectedDate={[]}
              dateFilters={[
                {
                  plug: "Period",
                  key: "period",
                  filterType: ["date_from", "date_to"],
                  value: date,
                  clearDate: false,
                  dateRange: true,
                  customWidth: "230px",
                },
              ]}
            />

            <Row>
              {props.topReportsWidgets
                .filter((_, index) => {
                  return index !== 3 && index !== 4 && index !== 5 && index !== 2;
                })
                .map((i, k) => (
                  <Col
                    xl={4}
                    md={6}
                    sm={6}
                    key={"_col_" + k}
                  >
                    <StyledCard className="mini-stats-wid fade-in-custom-animate-1s">
                      <CardBody>
                        {props.topReportsLoading && spinnerWidget}
                        <div className="d-flex" style={{ height: "65px" }}>
                          <div className="flex-grow-1">
                            <p className="text-muted fw-medium fade-in-custom-animate">
                              {i.title}
                            </p>
                            {/* {!props.topReportsLoading && ( */}
                            <h4 className="mb-0 fade-in-custom-animate">
                              {`${numberWithCommas(i.value)}`}
                            </h4>
                            {/* )} */}
                          </div>
                          <div className="d-flex justify-content-end align-items-center">
                            <div className="avatar-xs">
                              <span className="avatar-title rounded-circle bg-primary bg-soft text-primary font-size-18 fade-in-custom-animate">
                                <i className={i.icon} />
                              </span>
                            </div>
                          </div>
                        </div>
                      </CardBody>
                    </StyledCard>
                  </Col>
                ))}
            </Row>

            <Row>
              <Col xl={12}>
                <Card>
                  <CardBody id="pdf-exporter--offers">
                    <Row
                      className="justify-content-between align-middle mb-3"
                      data-html2canvas-ignore="true"
                    >
                      <Col
                        sm={6}
                        className="d-flex justify-content-start align-items-center"
                      >
                        <h5 className="m-0">Staff</h5>
                      </Col>
                      <Col
                        sm={6}
                        className="d-flex justify-content-end align-items-center h-[15px]"
                      >
                        <div className="float-end" style={{ height: 38 }}>
                          <Link
                            to="#"
                            onClick={() => handleChangeTableData("staff")}
                            className={`btn btn-success ${!tablesDataForExport?.staff && "disabled"
                              } me-2`}
                          >
                            <i className="fas fa-file-csv" />
                          </Link>
                        </div>
                      </Col>
                    </Row>
                    <Row className="justify-content-between"></Row>
                    <AggregatedTableForHR
                      tableName="staff"
                      data={props.staffData}
                      loader={props.staffLoaderData}
                    // setTablesDataForExport={handleUpdateTable}
                    />
                  </CardBody>
                </Card>
              </Col>
              <Col xl={12}>
                <Card>
                  <CardBody id="pdf-exporter--offers">
                    <Row
                      className="justify-content-between align-middle mb-3"
                      data-html2canvas-ignore="true"
                    >
                      <Col
                        sm={6}
                        className="d-flex justify-content-start align-items-center"
                      >
                        <h5 className="m-0">Extended data by offers</h5>
                      </Col>
                      <Col
                        sm={6}
                        className="d-flex justify-content-end align-items-center h-[15px]"
                      >
                        <div className="float-end" style={{ height: 38 }}>
                          <Link
                            to="#"
                            onClick={() => handleChangeTableData("offers")}
                            className={`btn btn-success ${!tablesDataForExport?.offers && "disabled"
                              } me-2`}
                          >
                            <i className="fas fa-file-csv" />
                          </Link>
                        </div>
                      </Col>
                    </Row>
                    <Row className="justify-content-between"></Row>
                    <AggregatedTableForHR
                      tableName="offers"
                      data={props.hrOffersData}
                      loader={props.hrOffersDataLoader}
                    // setTablesDataForExport={handleUpdateTable}
                    />
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </StyledContainer>
        ) : (
          ""
        )}
      </React.Fragment>
    </>
  );
};

const StyledContainer = styled(Container)`
    .loader-for--line-chart {
      transition: opacity 0.3s;
      opacity: 1;
      backdrop-filter: blur(4px);
      display: flex;
      width: 98%;
      height: 350px;
      position: absolute;
      z-index: 1;
    }
  `;

const StyledCard = styled(Card)`
    .loader-for-react-widget {
      position: absolute;
      left: 0;
      width: 100%;
      height: 100%;
      right: 0;
      bottom: 0;
      top: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: rgba(255, 255, 255, 0.3);
      z-index: 1;
    }
  `;

HROverview.propTypes = {
  history: PropTypes.any,
  topReportsFilters: PropTypes.object,
  topReportsWidgets: PropTypes.array,
  totalProfit: PropTypes.array,
  profitByDays: PropTypes.array,
  filter_data: PropTypes.object,
  getTopManagementReportsFilters: PropTypes.func,
  getProfitPlansWidgetData: PropTypes.func,
  topReportsLoading: PropTypes.bool,
  topReportsFiltersLoading: PropTypes.bool,
  setTopManagementReportsFilters: PropTypes.func,
  customFilters: PropTypes.object,
  customLoader: PropTypes.bool,
  getCustomFilters: PropTypes.func,
  aggregatedOfferData: PropTypes.object,
  loaderAggregatedOffer: PropTypes.bool,
  getAggregatedOfferProfit: PropTypes.func,
  user: PropTypes.object,
  permissions: PropTypes.any,
  setProfitPlansWidgetData: PropTypes.func,
  staffData: PropTypes.any,
  staffLoaderData: PropTypes.bool,
  getAggregatedStaffData: PropTypes.func,
  setAggregatedStaffData: PropTypes.func,
  getHRDetailedOffers: PropTypes.func,
  hrOffersData: PropTypes.any,
  hrOffersDataLoader: PropTypes.bool,
};

export default HROverview;
